import { render, staticRenderFns } from "./TeamProfile.vue?vue&type=template&id=c31598d6&"
import script from "./TeamProfile.vue?vue&type=script&lang=js&"
export * from "./TeamProfile.vue?vue&type=script&lang=js&"
import style0 from "./TeamProfile.vue?vue&type=style&index=0&id=c31598d6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports